export default __webpack_public_path__ + "static/media/02.b4a5da73.jpg";